

















import { Component, Prop, Vue } from "vue-property-decorator";
import { LabeledText } from "@/types/types";

@Component({})
export default class InformationCardValues extends Vue {
  @Prop({ default: null })
  values!: Array<LabeledText>;

  textBelowLabel(label: string) {
    if (label === "Events" || label === "Extra informatie") {
      return true;
    }

    return false;
  }
}
